// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SolutionOutlinedSvg from "@fishx/icons-svg/es/asn/SolutionOutlined";
import FishxIcon from '../components/FishxIcon';

var SolutionOutlined = function SolutionOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SolutionOutlinedSvg
  }));
};

SolutionOutlined.displayName = 'SolutionOutlined';
export default React.forwardRef(SolutionOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SolutionOutlined.js
// module id = 4170
// module chunks = 0